module.exports = __webpack_public_path__ + "img/solution_meeting_poster.6d174bc6.png";